__turbopack_context__.v({
  "tooltipDescription": "styles-module-scss-module__K2JzIa__tooltipDescription",
  "tooltipHeader": "styles-module-scss-module__K2JzIa__tooltipHeader",
  "tooltipImpact": "styles-module-scss-module__K2JzIa__tooltipImpact",
});
